import React from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router';

import { ReactComponent as CloseIcon } from 'assets/icons/close_dark.svg';
import styleGuide from 'constants/styleGuide';

const Background = styled.div`
  flex: 1;
  display: flex;
  min-width: 1200px;
  padding-bottom: 5%;
  flex-direction: column;

  background-color: #f3f4f6;
`;
const TitleBar = styled.div`
  display: flex;
`;
const CloseBtn = styled.button`
  padding: 2%;
`;
const ButtonContainer = styled.div`
  display: flex;
  margin: 0 auto;
  width: 80%;
  justify-content: flex-end;
`;
const ButtonMenu = styled.button`
  margin-right: 1%;
  padding: 0.8% 1.5%;
  font-weight: 700;
  font-size: 1.2rem;
  text-align: center;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  background-color: #fff;

  &:hover {
    background-color: #eee;
  }
`;
const ButtonSubmit = styled(ButtonMenu)`
  color: white;

  background-color: ${(props) => (props.disabled ? '#aaa' : styleGuide.palette.primary)};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#aaa' : styleGuide.palette.primaryHover)};
  }
`;

interface IProps {
  children: React.ReactNode;
  readyToSubmit?: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
}

const PopupFrame = ({ children, readyToSubmit = true, onSubmit = undefined, onClose = undefined }: IProps) => {
  const navigate = useNavigate();

  const clickCloseBtn = () => {
    if (onClose) onClose();
    navigate(-1);
  };

  return (
    <Background>
      <TitleBar className="titleBar">
        <CloseBtn className="closeIcon" onClick={clickCloseBtn}>
          <CloseIcon />
        </CloseBtn>
      </TitleBar>
      {children}
      {(onSubmit !== undefined || onClose !== undefined) && (
        <ButtonContainer className="buttonContainer">
          {onClose !== undefined && (
            <ButtonMenu className="buttonMenu" onClick={clickCloseBtn}>
              취소
            </ButtonMenu>
          )}
          {onSubmit !== undefined && (
            <ButtonSubmit className="buttonMenu buttonComplete" onClick={onSubmit} disabled={!readyToSubmit}>
              저장
            </ButtonSubmit>
          )}
        </ButtonContainer>
      )}
    </Background>
  );
};

export default PopupFrame;
